// Custom js for sub menu open
var menuOpen = document.querySelector('.extra-menu')
var subNavigation = document.querySelector('.sub-header-navigation-wrp')
var bodyClass = document.querySelector('body')

if(menuOpen){
   menuOpen.addEventListener('click', function() {
    menuOpen.classList.toggle('active');
    subNavigation.classList.toggle('open');
    bodyClass.classList.toggle('menu-active');
  });
}

// Custom js for sub menu open in sidebar
jQuery(document).ready(function ($) {
  $('.sidebar  .menu-item-has-children').on('click', function() {
      $(this).children().last().slideToggle();
      $(this).toggleClass('menu-active');
  });
});